import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import * as Events from '../lib/events';
import request from '@vaersaagod/tools/request';
import serialize from 'form-serialize';

export default el => {
    const dom = $(el);
    const form = dom.find('[data-form]');
    const formWrap = dom.find('[data-form-wrap]');
    const input = dom.find('[data-input]');
    const label = dom.find('[data-label]');
    const bg = dom.find('[data-bg]');
    const thanks = dom.find('[data-thanks]');

    const onSubmit = e => {
        e.preventDefault();
        const params = serialize(form.get(0));

        dom.addClass('is-processing');

        request
            .post('/')
            .accept('application/json')
            .send(params)
            .then(res => {
                console.log(res);
                dom.removeClass('is-processing');
                dom.addClass('is-success');
            }, error => {
                console.error('Error', error);
                dom.removeClass('is-processing');
                dom.addClass('is-error');
            });
    };


    const onInputChange = e => {
        const node = e.triggerTarget;
        const sibling = $(node).parent().find('[data-input]');
        if (node.value.length > 0 && !sibling.hasClass('has-value')) {
            sibling.addClass('has-value');
        } else if (node.value.length === 0 && sibling.hasClass('has-value')) {
            sibling.removeClass('has-value');
        }
    };

    const init = () => {
        input.on('change', onInputChange);
        form.on('submit', onSubmit);
    };

    const destroy = () => {
        input.off('change', onInputChange);
        form.off('submit', onSubmit);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ContactForm.js